(function () {
  class VaillantProductCard extends HTMLElement {
  connectedCallback() {
    this.productViews = [...this.querySelectorAll('[data-product-view]')];
    this.informationPanels = [...this.querySelectorAll('[data-product-information]')];
    this.swatches = [...this.querySelectorAll('[data-related-product]')];
    this.showSecondaryImage = this.dataset.showSecondaryImage === 'true';
    this.manualGalleryInteraction = false;

    this.initializeImages();
    this.bindGalleryControls();
    this.bindTouchGallery();
    this.bindSwatches();
    this.bindHoverImage();
  }

  initializeImages() {
    this.querySelectorAll('.vaillant-product-card__image').forEach((image) => {
      const slide = image.closest('[data-product-slide]');
      const markLoaded = () => slide?.classList.add('is-loaded');

      if (image.complete) {
        markLoaded();
      } else {
        image.addEventListener('load', markLoaded, { once: true });
        image.addEventListener('error', markLoaded, { once: true });
      }
    });
  }

  bindGalleryControls() {
    this.productViews.forEach((view) => {
      view.querySelector('[data-gallery-previous]')?.addEventListener('click', () => {
        this.moveGallery(view, -1);
      });

      view.querySelector('[data-gallery-next]')?.addEventListener('click', () => {
        this.moveGallery(view, 1);
      });
    });
  }

  bindTouchGallery() {
    this.productViews.forEach((view) => {
      const gallery = view.querySelector('[data-product-gallery]');
      const mediaLink = view.querySelector('[data-product-link]');
      if (!gallery || gallery.querySelectorAll('[data-product-slide]').length < 2) return;

      let touchStartX = 0;
      let touchStartY = 0;
      let tracking = false;
      let isHorizontalSwipe = false;
      let suppressClick = false;

      gallery.addEventListener(
        'touchstart',
        (event) => {
          if (event.touches.length !== 1) return;

          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
          tracking = true;
          isHorizontalSwipe = false;
          suppressClick = false;
        },
        { passive: true }
      );

      gallery.addEventListener(
        'touchmove',
        (event) => {
          if (!tracking || event.touches.length !== 1) return;

          const deltaX = event.touches[0].clientX - touchStartX;
          const deltaY = event.touches[0].clientY - touchStartY;

          if (!isHorizontalSwipe) {
            if (Math.abs(deltaX) < 10 && Math.abs(deltaY) < 10) return;

            if (Math.abs(deltaX) <= Math.abs(deltaY)) {
              tracking = false;
              return;
            }

            isHorizontalSwipe = true;
          }

          event.preventDefault();
        },
        { passive: false }
      );

      gallery.addEventListener(
        'touchend',
        (event) => {
          if (!tracking || !isHorizontalSwipe) {
            tracking = false;
            return;
          }

          tracking = false;

          const deltaX = event.changedTouches[0].clientX - touchStartX;
          if (Math.abs(deltaX) < 40) return;

          this.moveGallery(view, deltaX > 0 ? -1 : 1);
          suppressClick = true;
        },
        { passive: true }
      );

      gallery.addEventListener(
        'touchcancel',
        () => {
          tracking = false;
          isHorizontalSwipe = false;
        },
        { passive: true }
      );

      mediaLink?.addEventListener('click', (event) => {
        if (!suppressClick) return;

        event.preventDefault();
        suppressClick = false;
      });
    });
  }

  bindSwatches() {
    this.swatches.forEach((swatch) => {
      swatch.addEventListener('click', () => this.selectProduct(swatch.dataset.relatedProduct));
    });
  }

  bindHoverImage() {
    if (!this.showSecondaryImage || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    this.addEventListener('mouseenter', () => {
      if (this.manualGalleryInteraction) return;

      const activeView = this.getActiveView();
      if (activeView?.querySelectorAll('[data-product-slide]').length > 1) {
        this.showSlide(activeView, 1);
      }
    });

    this.addEventListener('mouseleave', () => {
      if (this.manualGalleryInteraction) return;

      const activeView = this.getActiveView();
      if (activeView) this.showSlide(activeView, 0);
    });
  }

  moveGallery(view, direction) {
    const slides = [...view.querySelectorAll('[data-product-slide]')];
    if (slides.length < 2) return;

    const activeIndex = Math.max(
      0,
      slides.findIndex((slide) => slide.classList.contains('is-active'))
    );
    const nextIndex = (activeIndex + direction + slides.length) % slides.length;

    this.manualGalleryInteraction = true;
    this.showSlide(view, nextIndex);
  }

  showSlide(view, index) {
    const slides = [...view.querySelectorAll('[data-product-slide]')];

    slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === index;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', String(!isActive));
    });

    view.querySelector('[data-gallery-progress]')?.style.setProperty('--gallery-slide-index', String(index));
  }

  selectProduct(productId) {
    const selectedView = this.productViews.find((view) => view.dataset.productView === productId);
    const selectedInformation = this.informationPanels.find(
      (panel) => panel.dataset.productInformation === productId
    );

    if (!selectedView || !selectedInformation) return;

    this.productViews.forEach((view) => {
      const isSelected = view === selectedView;
      view.hidden = !isSelected;
      if (isSelected) this.showSlide(view, 0);
    });

    this.informationPanels.forEach((panel) => {
      panel.hidden = panel !== selectedInformation;
    });

    this.swatches.forEach((swatch) => {
      const isSelected = swatch.dataset.relatedProduct === productId;
      swatch.classList.toggle('is-active', isSelected);
      swatch.setAttribute('aria-pressed', String(isSelected));
    });

    this.dataset.currentProduct = productId;
    this.manualGalleryInteraction = false;
  }

  getActiveView() {
    return this.productViews.find((view) => !view.hidden);
  }
}

  if (!customElements.get('product-card-vaillant')) {
    customElements.define('product-card-vaillant', VaillantProductCard);
  }
})();
